import { useState } from "react";

import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../components/ui/dialog";

const REASONS = [
  ["too_expensive", "Too expensive"], ["not_using", "Not using it"], ["missing_feature", "Missing a feature"],
  ["season_ended", "Season ended"], ["charged_by_mistake", "Charged by mistake"], ["other", "Other"],
];
const PLAN_NAMES = { clipboard_plus: "Clipboard+", chalkboard: "Chalkboard", league_os: "League OS" };

export function RefundDialog({ account, busy, onClose, onConfirm }) {
  const [reason, setReason] = useState(null);
  const [note, setNote] = useState("");
  const needsNote = reason === "other" && !note.trim();
  const plan = account ? PLAN_NAMES[account.subscription.tier] || account.subscription.tier : "";
  return (
    <Dialog open={!!account} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="refund-dialog" style={{ maxWidth: 420 }}>
        <DialogHeader>
          <DialogTitle>Refund and cancel</DialogTitle>
          <DialogDescription>
            Refunds {account?.email}&apos;s most recent payment in full and ends their {plan} plan now. This can&apos;t be undone.
          </DialogDescription>
        </DialogHeader>
        <div role="radiogroup" aria-label="Refund reason" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          {REASONS.map(([key, label]) => (
            <button key={key} type="button" role="radio" aria-checked={reason === key} data-testid={`refund-reason-${key}`}
                    onClick={() => setReason(key)}
                    style={{ padding: "10px 12px", borderRadius: 12, fontSize: 13, textAlign: "left", cursor: "pointer",
                      border: `1px solid ${reason === key ? "var(--chalk-board)" : "var(--chalk-border)"}`,
                      background: reason === key ? "var(--chalk-board)" : "#fff", color: reason === key ? "#fff" : "var(--chalk-board)",
                      transition: "background-color 150ms ease, color 150ms ease" }}>
              {label}
            </button>
          ))}
        </div>
        <textarea data-testid="refund-note" value={note} onChange={(e) => setNote(e.target.value.slice(0, 200))} rows={2}
                  placeholder={reason === "other" ? "What happened? (required)" : "Note (optional)"}
                  style={{ width: "100%", borderRadius: 12, border: "1px solid var(--chalk-border)", padding: 10, fontSize: 13, resize: "none" }} />
        <DialogFooter style={{ gap: 8 }}>
          <button type="button" onClick={onClose} data-testid="refund-cancel-btn"
                  style={{ padding: "9px 16px", borderRadius: 999, border: "1px solid var(--chalk-border)", background: "#fff", fontSize: 13, cursor: "pointer" }}>
            Keep plan
          </button>
          <button type="button" disabled={!reason || needsNote || busy} data-testid="refund-confirm-btn"
                  onClick={() => onConfirm(reason, note.trim())}
                  style={{ padding: "9px 16px", borderRadius: 999, border: "none", background: "var(--chalk-red)", color: "#fff", fontSize: 13,
                    fontWeight: 600, cursor: !reason || needsNote || busy ? "not-allowed" : "pointer", opacity: !reason || needsNote || busy ? 0.5 : 1 }}>
            {busy ? "Refunding…" : "Refund and cancel"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
